import React, { useState, useEffect } from 'react';
import Toast from './toast.jsx';
import toastService from '../../services/toastService.js';

/**
 * Toast Container Component
 * Manages and displays all active toast notifications
 */
const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    // Subscribe to toast service updates
    const unsubscribe = toastService.subscribe((updatedToasts) => {
      setToasts([...updatedToasts]);
    });

    // Cleanup subscription on unmount
    return unsubscribe;
  }, []);

  const handleCloseToast = (toastId) => {
    toastService.remove(toastId);
  };

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className="toasts-container">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={handleCloseToast}
        />
      ))}
    </div>
  );
};

export default ToastContainer;